// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../react-forms/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.googleSignIn {
  width: 191px;
  height: 46px;
  background-size: cover;
  cursor: pointer;
  margin: 0 auto;
  transition: opacity 0.2s;
  display: inline-block;
}

.googleContinue {
  min-width: 200px;
  height: 50px;
  color: #555555;
  font-weight: bold;
  line-height: 50px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #cccccc;
  border-radius: 30px;
  padding: 0 60px 0 55px;
  margin: 0 auto;
  cursor: pointer;
  background-color: #ffffff;
}
.googleContinue:hover {
  border-color: #dddddd;
  background-color: #f5f5f5;
  color: #555555;
}
.googleContinue:active {
  background-color: #f5f5f5;
  opacity: 0.9;
}
.googleContinue img {
  width: 30px;
  height: 30px;
  margin-right: 24px;
}

/*# sourceMappingURL=google-sign-in.css.map */
`, "",{"version":3,"sources":["webpack://./../public/sass/google-sign-in.scss","webpack://./../public/css/google-sign-in.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,YAAA;EACA,sBAAA;EACA,eAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;ACCF;;ADGA;EACE,gBAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;ACAF;ADEE;EACE,qBAAA;EACA,yBAAA;EACA,cAAA;ACAJ;ADGE;EACE,yBAAA;EACA,YAAA;ACDJ;ADIE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACFJ;;AAEA,6CAA6C","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
